/*
 * @overview: 项目访问统计
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2024-03-27 17:13:51
 */

import { options } from "../core";
import { getRouter, initService, accessService } from "../api/http";
let currentUrl = "";
let timeoutId = null;
let intervalId;

/**
 * 注册事件
 */
async function injectProjectAccess() {
  if (!options.useProjectAccess) {
    console.log("项目访问统计已关闭");
    return;
  } else if (!options.useAutoAccess) {
    console.log("项目访问统计运行中, 本次使用手动上报");
  } else {
    console.log("项目访问统计运行中");
  }
  // 初始化配置
  await init();
  // 开始检查地址栏变化
  options.useAutoAccess && startUrlChangeCheck();
}

/**
 * 地址变化监听
 */
function checkUrlChange() {
  if (window.location.href !== currentUrl) {
    console.log("地址栏变化:", window.location.href);
    currentUrl = window.location.href; // 地址栏变化 更新当前地址
    // 从当前地址中获取真实Path
    let curTruePath =
      window.location.pathname === "/"
        ? window.location.hash
        : window.location.pathname;
    curTruePath = filteredPaths(curTruePath);
    // 地址是否在文件中有匹配项
    let localFile = JSON.parse(localStorage.getItem("projectRouters")) || [];
    const foundItem = localFile.find((item) => item.path === curTruePath);
    if (foundItem) {
      // 清除之前的setTimeout
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      // 设置新的setTimeout
      timeoutId = setTimeout(() => {
        if (window.location.href === currentUrl) {
          accessTracker(curTruePath);
        } else {
          console.log("地址已变化，取消上报");
        }
      }, 3000);
    } else {
      console.log("未找到匹配的对象, 不上报此次访问");
    }
  }
}

function startUrlChangeCheck() {
  intervalId = setInterval(checkUrlChange, 1000);
}

function stopUrlChangeCheck() {
  clearInterval(intervalId);
}

// 当页面被隐藏时停止检查地址栏变化
document.addEventListener("visibilitychange", function () {
  if (document.visibilityState === "hidden") {
    options.useAutoAccess && stopUrlChangeCheck();
  } else {
    options.useAutoAccess && startUrlChangeCheck();
  }
});

// 当页面被关闭或刷新时停止检查地址栏变化
window.addEventListener("beforeunload", function () {
  options.useAutoAccess && stopUrlChangeCheck();
});

/**
 * 初始化配置
 */
async function init() {
  // 获取远程配置文件
  const routers = await getRouter();
  // 获取本地配置文件
  let localFile = localStorage.getItem("projectRouters");
  if (localFile) {
    // 对比文件是否相同，如果相同则不用上传更新
    let isEquals = arraysOfObjectsAreEqual(JSON.parse(localFile), routers);
    if (!isEquals) await executeInitService(routers);
  } else {
    await executeInitService(routers);
  }
}

/**
 * 上报访问
 */
async function accessTracker(path) {
  let params = {
    key: options.projectName,
    path: path,
  };
  const { ok } = await accessService(params);
  if (ok)
    console.log(
      `上报成功, 上报方式: ${options.useAutoAccess ? "自动" : "手动"}`
    );
}

/**
 * 上报访问-手动
 */
async function accessTracker_Manual(path) {
  // 地址是否在文件中有匹配项
  let localFile = JSON.parse(localStorage.getItem("projectRouters")) || [];
  const foundItem = localFile.find((item) => item.path === path);
  if (foundItem) {
    // 清除之前的setTimeout
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    // 设置新的setTimeout
    timeoutId = setTimeout(async () => {
      let params = {
        key: options.projectName,
        path: path,
      };
      const { ok } = await accessService(params);
      if (ok)
        console.log(
          `上报成功, 上报方式: ${options.useAutoAccess ? "自动" : "手动"}`
        );
    }, 3000);
  } else {
    console.log("未找到匹配的对象, 不上报此次访问");
  }
}

/**
 * 上传配置
 * @param {*} routers
 */
async function executeInitService(routers) {
  localStorage.setItem("projectRouters", JSON.stringify(routers));
  let params = {
    key: options.projectName,
    pageList: routers,
  };
  await initService(params);
}

/**
 * 对比文件是否一致
 * @param {*} arr1
 * @param {*} arr2
 * @returns
 */
function arraysOfObjectsAreEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }

  for (let i = 0; i < arr1.length; i++) {
    const obj1 = arr1[i];
    const obj2 = arr2[i];

    // 检查对象属性数量是否相同
    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
      return false;
    }

    // 检查对象属性值是否相同
    for (let key in obj1) {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }
  }

  return true;
}

/**
 * 格式化地址
 * @param {*} path
 * @returns
 */
var filteredPaths = (path) => {
  // 去掉路径中第一个字符为'/'之前的所有字符
  path = path.replace(/^[^/]*\//, "/");

  // 去掉路径中包含'?'及其后的所有字符
  path = path.replace(/\?.*/, "");

  // 去掉路径中包含'.'及其后的所有字符
  path = path.replace(/\..*/, "");

  return path;
};

export { injectProjectAccess, accessTracker_Manual };
